import React from 'react';
import Firebase from 'firebase';


export default class historyList extends React.Component {

    constructor() {
        super();
        this.state = {
        }
        this.renderItem = this.renderItem.bind(this);
        this.fecha = this.fecha.bind(this);
        this.hora = this.hora.bind(this);
    }


    componentWillMount() {
        var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
        logRef.on("value", resp => {
            this.setState({ logs: Object.values(resp.val()) })
        })
    }

    DateToFormattedString(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };


    fecha(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " ";
    };

    hora(d) {
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    }

    renderItem(log, i) {
        var d = new Date(log.timestamp)
        var classNombre;
        if (i % 2 === 0) {
            classNombre = "timeline-entry";
        } else {
            classNombre = "timeline-entry left-aligned";
        }
        var color;
        var accion;
        var tipo;
        var mensaje;
        switch (log.action) {
            case "add":
                color = "success"
                accion = "añadió"
                break;
            case "delete":
                color = "danger"
                accion = "eliminó"
                break;
            case "edit":
                color = "primary"
                accion = "editó"
                break;
            case "publish":
                color = "warning"
                accion = "publicó"
                break;
            default:
                color = "secundary"
                break;
        }
        switch (log.target.type) {
            case "user":
                var tipo = "un usuario";
                mensaje = <p>El administrador <b>{accion}</b> el usuario <b>{log.target.name}</b></p>;
                break;
            case "registro":
                var tipo = "un registro";
                mensaje = <p>El administrador <b>{accion}</b> el registro <b>{log.target.id}</b></p>;
                break;
            case "form":
                var tipo = "un formulario"
                mensaje = <p>El administrador <b>{accion}</b> el formulario <b>{log.target.name}</b></p>;
            default:
                break;
        }
        return (
            <div className="entry">
                <div className="title">
                    <h3><span>{this.fecha(d)}</span> <span>{this.hora(d)}</span></h3>
                    <p>{log.admin}</p>
                </div>
                <div className="body">
                    <p>{mensaje}</p>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="animated fadeIn" style={{background :"#FFF"}} >
                <div className="row">
                    <div className="timeline">
                        {this.state.logs ?
                            this.state.logs.reverse().map((log, i) => (
                                this.renderItem(log, i)
                            ))
                            :
                            ""
                        }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/history/historyList.js